import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import * as potentialAction from '../actions/potential.action';
import {map, switchMap, catchError, mergeMap, take, withLatestFrom, filter} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import * as fromStore from '../../../store';
import {isNullOrUndefined} from 'util';
import {PotentialService} from '../../potential.service';


@Injectable()
export class PotentialEffects {
  constructor(private actions: Actions, private potentialService: PotentialService, private store: Store<fromStore.AppState>) {
  }

  @Effect()
  getAllPotentials: Observable<Action> = this.actions.ofType(potentialAction.GET_ALL_POTENTIALS)
    .pipe(
      switchMap(() => {
        return this.potentialService.getAllPotentials()
          .map(res => new potentialAction.GetAllPotentialsSuccess(res))
          .catch(error => of(new potentialAction.GetAllPotentialsError(error)));
      })
    );

  @Effect()
  getPotential: Observable<Action> = this.actions.ofType(potentialAction.GET_POTENTIAL)
    .pipe(
      withLatestFrom(
        // select users.
        this.store.select(state => state.potentialsFeature.potentials.users),
        (action: any, users) => {
          // if no users present, proceed for API.
          if (isNullOrUndefined(users)) {
            return action;
          } else {
            // users exists in store.
            const potential = users.filter(p => p.id === action.payload)[0];
            if (!!potential) {
              // if required user is present in store, then return;
              return undefined;
            } else {
              // if required user not present in store, then proceed for API.
              return action;
            }
          }
        }
      ),
      filter(action => !!action),
      mergeMap(action => {
        return this.potentialService.getPotential(action.payload)
          .map(res => new potentialAction.GetPotentialSuccess(res))
          .catch(error => of(new potentialAction.GetPotentialError(error)));
      })
    );

  @Effect()
  approvePotential: Observable<Action> = this.actions.ofType(potentialAction.APPROVE_POTENTIAL)
    .map((action: potentialAction.ApprovePotential) => action.payload)
    .pipe(
      switchMap((payload) => {
        return this.potentialService.approvePotential(payload)
          .map(res => new potentialAction.UpdatePotentialSuccess(res))
          .catch(error => of(new potentialAction.UpdatePotentialError(error)));
      })
    );

  @Effect()
  rejectPotential: Observable<Action> = this.actions.ofType(potentialAction.REJECT_POTENTIAL)
    .map((action: potentialAction.RejectPotential) => action.payload)
    .pipe(
      switchMap((payload) => {
        return this.potentialService.rejectPotential(payload)
          .map(res => new potentialAction.UpdatePotentialSuccess(res))
          .catch(error => of(new potentialAction.UpdatePotentialError(error)));
      })
    );
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/potentials/store/effects/potential.effects.ts